import {axios as http} from "@/plugins/http"

export default class Api {
    static item(couponId, sourceId) {
        return http.get(`/api/v1/promocodes/coupon/${couponId}/${sourceId}`)
    }

    static lnkPost(couponId, sourceId) {
        return http.get(`/api/v1/promocodes/coupon/lnk-post/${couponId}/${sourceId}`)
    }
}
